import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';
import { ChipContainerProps } from './Chip.types';

export const ChipContainer = styled(Flexbox)<ChipContainerProps>`
  background-color: ${({backgroundColor}) => backgroundColor ? backgroundColor : 'white'};
  border-radius: 4px;
  padding: 4px 8px;
  height: 25px;
  font-size: 14px;
  align-items: center;
  margin-right: 8px;
  white-space: nowrap;
  
  button {
    background: none;
    padding: 0;

    :hover {
      background-color: #EEEEEE;
    }

    :active {
      background-color: #DFE3E8;
    }
  }
`;
